<template>
  <div class="head">
    <div class="box logo">
      <img  src="../img/my_logo.png">
      <h1><p class="logo_big">深圳市意达五金制品</p><p class="logo_min">工艺精湛&nbsp;&nbsp;|&nbsp;&nbsp;保障品质&nbsp;&nbsp;|&nbsp;&nbsp;始终如一</p></h1>
    </div>
    <div class="box link">
      <router-link 
      v-for="item in items"
      :key="item.link"
      :to="item.link"
      :exact="item.exact"
      @click.native="choose($event)"
      >
        {{ item.toname }}
      </router-link>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data(){
    return{
      items:[
      {
        toname:"主页",
        link:"/",
        exact: true,
      },
      {
        toname:"产品中心",
        link:"/product",
        exact: false,
      },
      {
        toname:"关于我们",
        link:"/about",
        exact: true,
      },
    ],
    }
  },
  methods:{
    choose(event){
      if ($(window).scrollTop() != 0) {
        $(".link a").css({
            color: "#555",
          })
      }else{
        $(".link a").css({
            color: "#fff",
          })
      }
      $(".router-link-active").css({
        color: "#87CEFA",
      });
      // console.log("表头文字染色了");
    },
    gun(){
      const jibun=this;
      //注册滚轮滚动的触发事件
      $(window).scroll(function(){
        //判断滚轮是否在最上方
        if ($(window).scrollTop() != 0) {
          //获取head元素,并设置他们的样式
          $(".head").css({
            background: "#fff",
            height: "80px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)"
          });
          $(".logo").css({
            filter: "grayscale(0%) brightness(100%)",
          })
          $(".link a").css({
            color: "#555",
          })
          jibun.choose();
        }else{
          //改回来
          $(".head").css({
            background:"transparent",
            height:"100px",
            boxShadow: "0 0 0px rgba(0, 0, 0, 0.5)"
          })
          $(".logo").css({
            filter: "grayscale(100%) brightness(1000%)",
          })
          $(".link a").css({
            color: "#fff",
          })
          jibun.choose();
        }
      })
    },

  },
  mounted() {
    const jibun=this;
    this.gun();
    window.onpopstate = function(event) {
      var newURL = window.location.href;
      // jibun.choose()
      // console.log("地址栏改动: " + newURL);
    };
    this.$router.afterEach((to, from) => {
      jibun.gun();
      var newURL = window.location.href;
     
      // console.log("地址栏改动: " + newURL);
    });

  }
}
</script>

<style scoped lang="less">
a{
  user-select: none;
}
.link a:hover{
  background: transparent;
}
.head{
    width: 100%;
    min-width: 1000px;
    height: 100%;
    transition:1s;
    /* background: rgba(135, 206, 250,0.3); */
    display: flex;
    justify-content: center;
    align-items: center;
}
.logo {
  display: flex;
  justify-content: center;
  filter: grayscale(100%) brightness(1000%);
  width: 100%;
}
.logo h1{
  font-size: 24px;
  /* margin: 30px 0; */
  padding: 0 30px;
  font-weight: 600;
  line-height: 1.25em;
  margin: 10px 0;
  /* border-right: 2px solid; */
}
.logo .logo_min{
  padding: 0;
  font-size: 14px;
  margin: 0;
}
.logo_big{
  margin: 0;
}
.logo img{
  width: 80px;
}
.link{
  padding: 20px;
}
.link a{ 
  color: #fff;
  margin: 0 40px;
  font-size: 21px;
}
/* 选择的页面 */
.link .router-link-exact-active{
  color: #87CEFA;
  /* background: ; */
}
.box{
  flex:1;
}
</style>